import React from 'react';
import styled from 'styled-components';
import { LoadingIndicator } from '../LoadingIndicator';
import { Overlay } from '../Overlay';

const ContainerStyled = styled(Overlay)`
  position: absolute;
  z-index: 999999;
  background-color: ${({ theme }) => theme.palette.background.card};
  display: flex;
  justify-content: center;
`;

export const CardLoadingOverlay: React.FC<PropTypes<
  typeof Overlay
>> = props => {
  return (
    <ContainerStyled {...props}>
      <LoadingIndicator />
    </ContainerStyled>
  );
};
